// Изменение к прошлому периоду: доля (0.18 — «+18 %»); прошлого нет или он нулевой — `null`.
export const relativeChange = (current: number, previous: number | null): number | null =>
  previous === null || previous === 0 ? null : (current - previous) / previous;

// Доля `part` от `whole`; целого нет — `null`.
export const share = (part: number, whole: number | null): number | null =>
  whole === null || whole === 0 ? null : part / whole;
